module.exports = __webpack_public_path__ + "static/media/Scuff_After.8a7b3ed3.jpg";